<template>
    <span class="invalid-feedback d-block"><span class="d-block">
        <span class="form-error-icon badge badge-danger text-uppercase">Error</span>
            <span class="form-error-message ml-1">{{ error }}</span>
        </span>
    </span>
</template>

<script>
    export default {
        props: ['error']
    }
</script>